'use client';

import React, { Fragment } from 'react';
import Header from '../components/Header';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Notification from '../components/Notification';


const NotificationPage: React.FC = () => {
    return (
        <Fragment>
            <div className="main-wrapper">
                <Header />

                <div className="main-content theme-dark-bg right-chat-active">
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="chat-wrapper p-3 w-100 position-relative scroll-bar bg-white theme-dark-bg">
                                        <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                            <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                                <Link to="/defaultsettings" className="d-inline-block mt-2"><i className="ti-arrow-left font-sm text-white"></i></Link>
                                                <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">Notificação</h4>
                                                {/* <Typography className="ms-auto text-primary font-xss" sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Ler tudo</Typography> */}
                                            </div>
                                        </div>

                                        <Notification />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};

export default NotificationPage;
